import { css } from 'styled-components';

// offset the positioning so that anchor links do not jump to a point hidden by the navigation bar
export const anchorJumpOffset = css`
    margin-top: calc((-1 * var(--size-masthead-height)) - var(--size-grid-unit));
    padding-top: calc(var(--size-masthead-height) + var(--size-grid-unit));
`;

// this will be used as a mask, so is solid black
const dottedSvg = () => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <style>
        * {
            fill:#000000;
        }
        rect {
            width: 1px;
            height: 1px
        }
    </style>
    <rect x="9" y="3"/>
    <rect x="15" y="3"/>
    <rect x="21" y="3"/>
    <rect x="27" y="3"/>
    <rect x="33" y="3"/>
    <rect x="39" y="3"/>
    <rect x="45" y="3"/>
    <rect x="51" y="3"/>
    <rect x="57" y="3"/>
    <rect x="9" y="9"/>
    <rect x="3" y="9"/>
    <rect x="15" y="9"/>
    <rect x="21" y="9"/>
    <rect x="27" y="9"/>
    <rect x="33" y="9"/>
    <rect x="39" y="9"/>
    <rect x="45" y="9"/>
    <rect x="51" y="9"/>
    <rect x="57" y="9"/>
    <rect x="9" y="15"/>
    <rect x="3" y="15"/>
    <rect x="15" y="15"/>
    <rect x="21" y="15"/>
    <rect x="27" y="15"/>
    <rect x="33" y="15"/>
    <rect x="39" y="15"/>
    <rect x="45" y="15"/>
    <rect x="51" y="15"/>
    <rect x="57" y="15"/>
    <rect x="9" y="21"/>
    <rect x="3" y="21"/>
    <rect x="15" y="21"/>
    <rect x="21" y="21"/>
    <rect x="27" y="21"/>
    <rect x="33" y="21"/>
    <rect x="39" y="21"/>
    <rect x="45" y="21"/>
    <rect x="51" y="21"/>
    <rect x="57" y="21"/>
    <rect x="9" y="27"/>
    <rect x="3" y="27"/>
    <rect x="15" y="27"/>
    <rect x="21" y="27"/>
    <rect x="27" y="27"/>
    <rect x="33" y="27"/>
    <rect x="39" y="27"/>
    <rect x="45" y="27"/>
    <rect x="51" y="27"/>
    <rect x="57" y="27"/>
    <rect x="9" y="33"/>
    <rect x="3" y="33"/>
    <rect x="15" y="33"/>
    <rect x="21" y="33"/>
    <rect x="27" y="33"/>
    <rect x="33" y="33"/>
    <rect x="39" y="33"/>
    <rect x="45" y="33"/>
    <rect x="51" y="33"/>
    <rect x="57" y="33"/>
    <rect x="9" y="39"/>
    <rect x="3" y="39"/>
    <rect x="15" y="39"/>
    <rect x="21" y="39"/>
    <rect x="27" y="39"/>
    <rect x="33" y="39"/>
    <rect x="39" y="39"/>
    <rect x="45" y="39"/>
    <rect x="51" y="39"/>
    <rect x="57" y="39"/>
    <rect x="9" y="45"/>
    <rect x="3" y="45"/>
    <rect x="15" y="45"/>
    <rect x="21" y="45"/>
    <rect x="27" y="45"/>
    <rect x="33" y="45"/>
    <rect x="39" y="45"/>
    <rect x="45" y="45"/>
    <rect x="51" y="45"/>
    <rect x="57" y="45"/>
    <rect x="9" y="51"/>
    <rect x="3" y="51"/>
    <rect x="15" y="51"/>
    <rect x="21" y="51"/>
    <rect x="27" y="51"/>
    <rect x="33" y="51"/>
    <rect x="39" y="51"/>
    <rect x="45" y="51"/>
    <rect x="51" y="51"/>
    <rect x="57" y="51"/>
    <rect x="9" y="57"/>
    <rect x="3" y="57"/>
    <rect x="15" y="57"/>
    <rect x="21" y="57"/>
    <rect x="27" y="57"/>
    <rect x="33" y="57"/>
    <rect x="39" y="57"/>
    <rect x="45" y="57"/>
    <rect x="51" y="57"/>
    <rect x="57" y="57"/>
    <path d="M5 3h-1v-1h-1v1h-1v1h1v1h1v-1h1v-1z"/>
</svg>
`;

export const dottedPatternMaskImage = `url('data:image/svg+xml, ${encodeURIComponent(dottedSvg())}')`;

export const dottedPattern = css`
    position: relative;
    &:before {
        content: '';
        position: absolute;
        z-index: var(--zIndex-buried);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--color-body-patterns);
        mask-image: ${dottedPatternMaskImage};
        mask-repeat: repeat;
        mask-size: 60px 60px;
        mask-position: 0 6px;
    }
`;
